export default __webpack_public_path__ + "static/media/invoice_2.59315124.PNG";